const STYLE = {
  apple_prefetch:   { label: 'Apple prefetch', cls: 'bg-zinc-700 text-zinc-300' },
  gmail_proxy:      { label: 'Gmail proxy',    cls: 'bg-zinc-700 text-zinc-300' },
  security_scan:    { label: 'Scanner',        cls: 'bg-zinc-700 text-zinc-300' },
  prefetch:         { label: 'Prefetch',       cls: 'bg-zinc-700 text-zinc-300' },
  likely_bot:       { label: 'Likely bot',     cls: 'bg-zinc-800 text-zinc-400' },
  unknown:          { label: 'Unknown',        cls: 'bg-zinc-800 text-zinc-400' },
  likely_human:     { label: 'Likely human',   cls: 'bg-amber-900/40 text-amber-300' },
  confirmed_human:  { label: 'Confirmed human',cls: 'bg-orange-900/40 text-orange-300' },
  active_reading:   { label: '🔥 Reading now', cls: 'bg-red-900/50 text-red-300' },
  // Reply-class labels — surfaced when reply events are rendered through this badge.
  positive:         { label: 'Positive reply', cls: 'bg-emerald-900/40 text-emerald-300' },
  negative:         { label: 'Negative reply', cls: 'bg-red-900/40 text-red-300' },
  neutral:          { label: 'Neutral reply',  cls: 'bg-zinc-800 text-zinc-300' },
  out_of_office:    { label: 'OOO',            cls: 'bg-blue-900/40 text-blue-300' },
  unsubscribe:      { label: 'Unsubscribe',    cls: 'bg-rose-900/50 text-rose-300' },
};

// [v3 polish] 3: confidence pill + "needs review" affordance when conf < 0.6.
// `needsReview` may also arrive pre-computed on the event; we recompute when
// only confidence is supplied so this component stays self-contained.
export function ClassificationBadge({ classification, confidence, needsReview }) {
  const s = STYLE[classification] || STYLE.unknown;
  const confNum = typeof confidence === 'number' && Number.isFinite(confidence)
    ? Math.max(0, Math.min(1, confidence))
    : null;
  const review = needsReview === true || (confNum != null && confNum < 0.6);
  // Confidence pill colour: green ≥0.85, amber 0.6-0.85, red <0.6.
  const confCls = confNum == null
    ? 'opacity-60'
    : confNum >= 0.85 ? 'text-emerald-400'
    : confNum >= 0.6  ? 'text-amber-300'
    : 'text-rose-300';
  return (
    <span className="inline-flex items-center gap-1 flex-wrap">
      <span className={`inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs ${s.cls}`}>
        {s.label}
        {confNum != null && (
          <span className={confCls}>{(confNum * 100).toFixed(0)}%</span>
        )}
      </span>
      {review && (
        <span
          title="Confidence below 0.6 — please review"
          className="rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wider bg-rose-950/60 text-rose-300 border border-rose-800/60"
        >
          Needs review
        </span>
      )}
    </span>
  );
}
